import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { jsx } from 'react/jsx-runtime';

var _templateObject, _templateObject2;
const SkipLinkWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "skipLink__SkipLinkWrapper",
  componentId: "sc-onmfdm-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  overflow: hidden;\n  white-space: nowrap;\n"])));
const SkipLinkAnchor = /*#__PURE__*/styled.a.withConfig({
  displayName: "skipLink__SkipLinkAnchor",
  componentId: "sc-onmfdm-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: -9999em;\n  top: -1rem;\n  z-index: 1;\n  display: inline-block;\n  margin-inline-start: ", ";\n  padding: ", ";\n  border-bottom-left-radius: ", ";\n  border-bottom-right-radius: ", ";\n  transition: ", ";\n\n  [dir='rtl'] & {\n    left: auto;\n    right: -9999em;\n\n    &:focus {\n      left: auto;\n      right: 0;\n    }\n  }\n\n  &:focus {\n    left: 0;\n    top: 0;\n    background: ", ";\n    color: ", ";\n  }\n\n  &:focus-visible {\n    box-shadow: ", ";\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing.baseSpacing;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return "0 ".concat(theme.spacing.halfSpacing);
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.radii.half;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.radii.half;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return "top ".concat(theme.transitionsMs.fast);
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.colors.primary.dark;
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.colors.primary.contrastText;
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return "0 0 0 2px ".concat(theme.colors.primary.light);
});
const SkipLink = /*#__PURE__*/forwardRef(function SkipLink(_ref9, ref) {
  let {
    children,
    href,
    ...rest
  } = _ref9;
  return /*#__PURE__*/jsx(SkipLinkWrapper, {
    children: /*#__PURE__*/jsx(SkipLinkAnchor, {
      href: href,
      ref: ref,
      ...rest,
      children: children
    })
  });
});

export { SkipLink };
